import { render, staticRenderFns } from "./Lviv.vue?vue&type=template&id=65ec62c4"
import script from "./Lviv.vue?vue&type=script&lang=js"
export * from "./Lviv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports